<template>
  <div v-if="content" v-editable="content" id="home-page">
    <!-- <illustration :content="{title: 'Découvrez City Aventure'}" id="illu"></illustration> -->
    <div class="home-content">
      <component :content="blok" :key="blok._uid" v-for="blok in content.body" :is="blok.component"></component>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  name: "home",
  data() {
    return {
      content: null
    };
  },
  created() {
    this.fetchData();
    if (this.$storyblok) {
      this.$storyblok.init();
      this.$storyblok.on(["change", "published"], () =>
        window.location.reload()
      );
      this.$storyblok.on("input", ({ story }) => {
        this.content = story.content;
      });
    }
  },
  methods: {
    async fetchData() {
      const { data } = await api.get(
        `cdn/stories/${this.$i18n.locale}/pages/index`
      );
      this.content = data.story.content;
    }
  }
};
</script>

<style lang="scss">
#home-page {
  #illu {
    height: 130vh;
  }
}
.home-content {
  position: relative;
  background-color: #fff;
}

@media screen and (max-width: 976px) {
  #home-page {
    #illu {
      height: 130vh;
    }
    .slider {
      height: 250px;
      .slides {
        li {
          .slider-content {
            h2 {
              font-size: 19px;
            }
          }
        }
      }
    }
  }
}
</style>

